export class LinkType {
  public description?: string;
}
